import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['helpModal'];

  connect() {
    this.boundDocumentClick = this.onDocumentClick.bind(this);
  }

  disconnect() {
    document.removeEventListener('click', this.boundDocumentClick);
  }

  openHelpModal(event) {
    event.preventDefault();
    event.stopPropagation();
    this.helpModalTarget.classList.remove('hidden');
    requestAnimationFrame(() => {
      document.addEventListener('click', this.boundDocumentClick);
    });
  }

  onDocumentClick(event) {
    if (event.target === this.helpModalTarget) {
      this.helpModalTarget.classList.add('hidden');
      document.removeEventListener('click', this.boundDocumentClick);
    }
  }
}
